// @ts-nocheck
export const GET_SCHEDULE_REQUEST = "GET_SCHEDULE_REQUEST";
export const GET_SCHEDULE_SUCCESS = "GET_SCHEDULE_SUCCESS";
export const GET_SCHEDULE_FAILURE = "GET_SCHEDULE_FAILURE";
export const FETCH_SINGLE_POSITION_DATA_REQUEST =
  "FETCH_SINGLE_POSITION_DATA_REQUEST";
export const FETCH_SINGLE_POSITION_DATA_SUCCESS =
  "FETCH_SINGLE_POSITION_DATA_SUCCESS";
export const FETCH_SINGLE_POSITION_DATA_FAILURE =
  "FETCH_SINGLE_POSITION_DATA_FAILURE";

// claim reimbursemnet
export const CLAIM_REIMBURSEMENT_REQUEST = "CLAIM_REIMBURSEMENT_REQUEST";
export const CLAIM_REIMBURSEMENT_SUCCESS = "CLAIM_REIMBURSEMENT_SUCCESS";
export const CLAIM_REIMBURSEMENT_FAILURE = "CLAIM_REIMBURSEMENT_FAILURE";

// accept reimbursement
export const ACCEPT_REIMBURSEMENT_REQUEST = "ACCEPT_REIMBURSEMENT_REQUEST";
export const ACCEPT_REIMBURSEMENT_SUCCESS = "ACCEPT_REIMBURSEMENT_SUCCESS";
export const ACCEPT_REIMBURSEMENT_FAILURE = "ACCEPT_REIMBURSEMENT_FAILURE";

// reject reimbursement
export const REJECT_REIMBURSEMENT_REQUEST = "REJECT_REIMBURSEMENT_REQUEST";
export const REJECT_REIMBURSEMENT_SUCCESS = "REJECT_REIMBURSEMENT_SUCCESS";
export const REJECT_REIMBURSEMENT_FAILURE = "REJECT_REIMBURSEMENT_FAILURE";